<template>
  <div>
    <center class="padding-top: 50px; h1">
  <div v-if="center.lat">
    {{center}}

  </div>
  <div v-else>
    loading..
  </div>
    </center>
  </div>
</template>
<script>
export default {
  name: 'GetLocaiton',
  data () {
    return {
      center: {}
    }
  },
  async mounted () {
    await this.geolocate()
  },
  methods: {
    async geolocate () {
      await navigator.geolocation.getCurrentPosition(
        async (position) => {
          const center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          if (center) {
            this.center = center
            console.log('this.center', center)
          }
        },
        (error) => {
          this.center.lat = null
          this.center.lng = null
          console.log('this.center err: ', this.center)
          console.log('error map :', error.message)
        }
      )
    }
  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/GetLocation.vue